import { useSelector } from 'react-redux'

import { isGpsOnly } from '@/features/domain/user'

export function useIsGpsOnly() {
  return useSelector(isGpsOnly)
}
